import { UitkPill } from "@egds/react-core/pill";
import * as React from "react";
import { TripTypePillProps } from "components/flexComponents/Flights/typings";
import { locKeys } from "./l10";

export const TripTypePill = (props: TripTypePillProps) => {
  const { formatText, moduleId, tripTypePillToggleState } = props;

  return (
    <div>
      <UitkPill
        onChange={props.filterAllDeals}
        checked={tripTypePillToggleState == "allDeals"}
        active={tripTypePillToggleState == "allDeals"}
        id={`${moduleId}-AllDealsPill`}
      >
        {formatText(locKeys.flightAllDealsText)}
      </UitkPill>
      <UitkPill
        onChange={props.filterOneWay}
        checked={tripTypePillToggleState == "oneWay"}
        active={tripTypePillToggleState == "oneWay"}
        id={`${moduleId}-OneWayPill`}
      >
        {formatText(locKeys.flightOneWayText)}
      </UitkPill>
      <UitkPill
        onChange={props.filterRoundTrip}
        checked={tripTypePillToggleState == "roundTrip"}
        active={tripTypePillToggleState == "roundTrip"}
        id={`${moduleId}-RoundTripPill`}
      >
        {formatText(locKeys.flightRoundTripText)}
      </UitkPill>
    </div>
  );
};
